<div class="max-w-2xl mx-auto rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <h3 class="titre3">{{ 'USERS_MANAGEMENT.CREATE_FICTITIOUS_USER' | translate }}</h3>
  </div>
  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    <div class="mb-6">
      <label class="block mb-2 text-sm font-medium">{{ 'USERS_MANAGEMENT.VIEWING_ENTITY' | translate
      }}</label>
      @if (singleEntity) {
        <div>
          <span class="text-sm">{{singleEntity.name}}</span>
        </div>
      } @else {
        <select title="entite" id="entity-select" [(ngModel)]="selectedEntity" (change)="onEntitySelected($event)"
          class="w-full p-2 border rounded" [attr.aria-label]="'USERS_MANAGEMENT.SELECT_ENTITY' | translate ">
          @for (entity of entities; track entity) {
            <option [value]="entity.id">{{entity.name}}</option>
          }
        </select>
      }
    </div>

    <div class="mb-4 mt-2">
      <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.TAGS' | translate }}</span>
      <select #etiquetteSelect title="TAGS" id="etiquettes" (change)="onEtiquetteSelected($event, etiquetteSelect)"
        class="w-full p-2 border rounded">
        <option value="">{{ 'USERS_MANAGEMENT.SELECT_TAG' | translate }}</option>
        @for (etiquette of availableEtiquettes; track etiquette) {
          <option [value]="etiquette.etiquetteId">
            {{ etiquetteService.getNomLocalise(etiquette.locales) }}
          </option>
        }
      </select>

      @if (selectedEtiquettes.length > 0) {
        <div class="mt-3">
          <h4 class="font-semibold">{{ 'USERS_MANAGEMENT.SELECTED_TAGS' | translate }}:</h4>
          <ul class="list-disc list-inside">
            @for (etiquette of selectedEtiquettes; track etiquette) {
              <li>
                {{ etiquetteService.getNomLocalise(etiquette.locales) }}
                <button (click)="removeSelectedEtiquette(etiquette.etiquetteId)" class="ml-2 text-rougeNovo">
                  {{ 'USERS_MANAGEMENT.REMOVE' | translate }}
                </button>
              </li>
            }
          </ul>
        </div>
      }
    </div>

    <div class="mb-6">
      <label for="creation-method" class="block mb-2 text-sm font-medium">{{
      'USERS_MANAGEMENT.CREATION_METHOD' | translate }}</label>
      <select id="creation-method" [(ngModel)]="creationMethod" class="w-full p-2 border rounded">
        <option value="manual">{{ 'USERS_MANAGEMENT.MANUAL_ADDITION' | translate }}</option>
        <option value="excel">{{ 'USERS_MANAGEMENT.IMPORT_FROM_EXCEL' | translate }}</option>
      </select>
    </div>

    @if (creationMethod === 'excel') {
      <div class="mb-6">
        <div class="mb-4">
          <button class="px-4 py-2 btn-primary-novo" (click)="downloadExcelTemplate()">{{
          'USERS_MANAGEMENT.DOWNLOAD_EXCEL_TEMPLATE' | translate }}</button>
        </div>
        <div class="mb-4">
          <input type="file" (change)="onFileSelected($event)" accept=".xlsx, .xls"
            title="{{ 'USERS_MANAGEMENT.SELECT_EXCEL_FILE' | translate }}" class="text-sm" />
          </div>
          @if (utilisateursExcel.length > 0) {
            <div class="overflow-x-auto mt-4">
              <table class="mat-table-novo divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col"
                      class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {{ 'USERS_MANAGEMENT.FIRST_NAME' | translate }}
                    </th>
                    <th scope="col"
                      class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {{ 'USERS_MANAGEMENT.LAST_NAME' | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody class="mat-table-novo divide-y divide-gray-200">
                  @for (user of utilisateursExcel; track user) {
                    <tr>
                      <td class="px-4 py-2 whitespace-nowrap text-xs text-gray-900">
                        {{user.prenom}}
                      </td>
                      <td class="px-4 py-2 whitespace-nowrap text-xs text-gray-900">
                        {{user.nom}}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @if (utilisateursExcel.length === 0 && selectedFile) {
            <div class="mt-4 text-rougeNovo">
              {{ 'USERS_MANAGEMENT.NO_USERS_IN_FILE' | translate }}
            </div>
          }
        </div>
      }

      @if (creationMethod === 'manual') {
        <div class="mb-6">
          <div class="flex space-x-2 mb-4">
            <div class="flex-grow">
              <input
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                placeholder="{{ 'USERS_MANAGEMENT.FIRST_NAME' | translate }}" [(ngModel)]="manualUser.firstName">
              </div>
              <div class="flex-grow">
                <input
                  class="w-full px-3 py-2 text-sm  border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  placeholder="{{ 'USERS_MANAGEMENT.LAST_NAME' | translate }}" [(ngModel)]="manualUser.lastName">
                </div>
              </div>
            </div>
          }

        </div>
        <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end">
          <button (click)="onCancel()" type="button" class="btn-secondary-novo">
            {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
          </button>
          <button (click)="onConfirm()" type="submit"
            class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed"
            [disabled]="isCreateButtonDisabled() || isLoading">
            @if (!isLoading) {
              <span>{{ 'USERS_MANAGEMENT.CREATE' | translate }}</span>
            }
            @if (isLoading) {
              <mat-spinner [diameter]="24" [color]="'accent'"></mat-spinner>
            }
          </button>
        </div>
      </div>